import React, {useEffect} from 'react';
import { Link } from "react-router";
import epstyles from "../../../../styles/SuccessPaymentEP.module.scss";
import { URLS } from "../../../../utility/constants/appConstants";
import tempJson from "../../../../json/fallbackglobalvariables.json";
import { useSelector } from "react-redux";

const PaymentSuccessEP = () => {

  const customerSummary = useSelector((state) => state.login.customerInfo);

  window.scrollTo(0, 0);
  const labels = { ...tempJson.acc };
  const queryString = window.location.search != ""?window.location.search:"";
  if(typeof labels.successNote === 'string'){
    labels.successNote = labels.successNote.replace('{EMAIL}', customerSummary?.[0]?.EmailAddress || '');
  }
  let successProps = {};
  const epSuccess = sessionStorage.getItem("epsuccessProps");
  if(epSuccess){
    successProps = JSON.parse(epSuccess);
  }

  var cardIcon = '';
  switch (successProps.cashSubTyp) {
  case 'AMX':
    cardIcon = 'AmericanExpress';
    break;
  case 'DCV':
    cardIcon = 'Discover';
    break;
  case 'MCD':
    cardIcon = 'Mastercard';
    break;
  case 'VIS':
    cardIcon = 'Visa';
    break;
  case 'CHK':
    cardIcon = 'Checking';
    break;
  default: cardIcon = ''; break;
  }

  const handlePrint = (e) => {
    e.preventDefault();
    window.print();
  };

  useEffect(() => {
    
    return () => {
      sessionStorage.removeItem("epsuccessProps");
    }
  }, []);
  

  return (
    <div>
      <div className={`${epstyles['componentWrapper']} bg-gray-100 mb-40 p-md-30 mb-40 tru-mma-main-wrapper tru-mma-main-wrapper--summary`}>
        <div className='container-fluid'>
          <div className={`row ${epstyles['successBlock']}`}>
            <div className='col-12 p-0 text-center'>
              <div className={`gfs-36 gfs-lg-48 gfw-3 glh-1 ${epstyles['bgGreen']}`}>
                {labels.congratulations}
              </div>
              <div className='my-30'>
                <img
                  src='/images/check-circle-solid.svg'
                  alt='Success'
                  className={`${epstyles['mma-success']} img-fluid`}
                />
              </div>
              <div className={`gfs-16 gfs-lg-28 gfw-3 glh-1_1 mb-30 ${epstyles['sectionSubtitle']}`}>
                <span dangerouslySetInnerHTML={{ __html: labels.successMsg }} />{successProps.confNum}
                <span />
              </div>
              
              <div className={`row gfs-20 gfw-2 mb-25 ${epstyles['enrolled']}`}>
                <div className='col-12'>
                  {labels.successNote}
                </div>
              </div>
              <div className='row'>
                <div className='col-12 pt-2'>
                  <Link to={URLS.payments +queryString} className={`${epstyles['btn']} ${epstyles['btnGray']} ${epstyles['btnLarge']} btn-lg gfw-4 text-white bg-gray-300`}>
                    {labels.returnPaymentText}
                  </Link>&nbsp;
                  <a href='#' onClick={handlePrint} className={`${epstyles['btn']} ${epstyles['btnOrange']} ${epstyles['btnLarge']} btn-lg btn-primary gfw-4 print-order-result`}>
                    {labels.printRecordText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessEP;